import React, { useContext } from 'react';
import { Navigate } from 'react-router';

import { UserContext } from './context/UserContext';

// CRM de leads (`/admin/leads`) y panel analítico del túnel (`/admin/tunnel`:
// embudo y CSV): los trabajan el equipo comercial (permiso `ventas`) y el
// superadmin. Es un permiso aparte y NO un superadmin regalado a propósito:
// superadmin abre cobranza, planes, API keys, impersonación y el minteo de
// sesiones del túnel (que no tiene UI), y ventas solo necesita leads y su panel.
const VentasGuard = ({ children }) => {
  const { user } = useContext(UserContext);

  // Wait for user data to load before deciding
  if (!user) return null;

  if (!user?.permissions?.superadmin && !user?.permissions?.ventas) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default VentasGuard;
